'use strict';

function dashboardSharingPopover () {
  $('.dashboard-sharing-popover').popover({
    trigger: 'click',
    container: 'body',
    placement: 'bottom',
    html: true
  });
}

module.exports = dashboardSharingPopover;
